import { IconType } from "react-icons/lib";
import {
    TbBeach,
    TbCalendarOff,
    TbCar,
    TbFlag,
    TbMedicineSyrup,
    TbTrekking,
    TbUrgent,
    TbWalletOff,
} from "react-icons/tb";

import { softColors } from "./colors";
import { DRIVER_STATUS } from "./status";

export type DriverStatusColumnType = {
    status: DriverColumnStatus;
    component: () => IconType;
    class: string;
    hover: string;
    payment: boolean;
    bg: string;
    text: string;
};

export type DriverStatusColumnListType = DriverStatusColumnType[];

export type DriverColumnStatus = (typeof DRIVER_STATUS)[keyof typeof DRIVER_STATUS];
export const driverStatuses: DriverStatusColumnListType = [
    {
        status: DRIVER_STATUS.WORKING,
        component: () => TbCar,
        payment: true,
        ...softColors.green,
    },
    {
        status: DRIVER_STATUS.OVERTIME_PERMIT,
        component: () => TbTrekking,
        payment: false,
        ...softColors.indigo,
    },
    {
        status: DRIVER_STATUS.FREE_DAY,
        component: () => TbCalendarOff,
        payment: true,
        ...softColors.blue,
    },
    {
        status: DRIVER_STATUS.EXCUSED_LEAVE,
        component: () => TbUrgent,
        payment: false,
        ...softColors.purple,
    },
    {
        status: DRIVER_STATUS.PUBLIC_HOLIDAY,
        component: () => TbFlag,
        payment: true,
        ...softColors.orange,
    },
    {
        status: DRIVER_STATUS.UNPAID_LEAVE,
        component: () => TbWalletOff,
        payment: false,
        ...softColors.pink,
    },
    {
        status: DRIVER_STATUS.SICK_LEAVE,
        component: () => TbMedicineSyrup,
        payment: true,
        ...softColors.yellow,
    },
    {
        status: DRIVER_STATUS.ANNUAL_LEAVE,
        component: () => TbBeach,
        payment: true,
        ...softColors.brown,
    },
];
